<template>
  <div class="Login">
    <div class="container">
      <div class="card">
        <img src="@/assets/img/logo.png" alt="logo cayros">
        <input class="input"  v-model="email" type="text" placeholder="Correo Electrónico">
        <input class="input"  v-model="password" type="password" placeholder="Contraseña">
        <button class="button is-link is-rounded" @click="login">Ingresar</button>
      </div>
    </div>
  </div>
</template>

<script>
// import 'bulma'
import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  data: () => ({
    email: '',
    password: ''
  }),
  mounted () {
  },
  methods: {
    login () {
      firebase.auth().signInWithEmailAndPassword(this.email, this.password)
      .then( () => {
        this.$router.replace('/main')
      })
      .catch(({code, message}) => {
        console.error(code, message)
      })
    }
  }
}
</script>

<style lang="sass" scoped>
@import "bulma"
@import '../assets/css/_variables.sass'
.container
  width: 350px
  min-height: 100vh
  display: flex
  justify-content: center
  flex-direction: column
  .card
    padding: 40px
    display: grid
    grid-template-columns: 1fr
    grid-gap: 20px
  img
    width: 70px
    margin: 0 auto
    margin-bottom: 25px
  input
    box-sizing: border-box
  button.is-link
    width: 100%
    box-sizing: border-box
    height: 50px
</style>